import { useNavigate, Navigate, useLocation } from "react-router-dom";
import useAuth from "./useAuth.jsx";

export default function RequireAuth({ children })
{
    const { authstatus } = useAuth();
    const location = useLocation();
    
    return authstatus === true ? children : <Navigate to="/login" replace state={{ path: location.pathname }} />;
}
